import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'

export default async function dashboard (state) {
  const Dashboard = (await import(/* webpackChunkName: 'component-dashboard' */ '../../components/dashboard')).default
  const { mode, options } = store.getState()[appSlice.name]

  return new Dashboard({
    user: state.get('user'),
    allowRedirects: options.allowRedirects,
    mode,
    state
  })
}
